module.exports = __webpack_public_path__ + "img/img_military.de8c3bb5.png";